import { useState, type ReactNode } from 'react'
import { Box, Text } from '@mantine/core'
import type { ProjectRow } from '@/types/api'
import { resolveUploadsUrl } from '@/lib/uploads'

type P = Pick<ProjectRow, 'name' | 'color' | 'icon' | 'icon_url'>

export function ProjectIcon({
  project,
  boxSize = 20,
  emergency,
}: {
  project: P
  boxSize?: number
  emergency?: boolean
}) {
  const [broken, setBroken] = useState(false)

  const slot = (inner: ReactNode) => (
    <Box
      w={boxSize}
      h={boxSize}
      style={{
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        border: emergency ? '3px solid var(--mantine-color-red-7)' : undefined,
        borderRadius: emergency ? Math.max(8, Math.round(boxSize / 2.2)) : undefined,
        boxShadow: emergency ? '0 0 0 3px rgba(255, 0, 0, 0.22)' : undefined,
      }}
    >
      {inner}
    </Box>
  )

  if (project.icon && !project.icon_url) {
    return slot(
      <Text component="span" fz={Math.round(boxSize * 0.85)} lh={1} style={{ lineHeight: 1 }}>
        {project.icon}
      </Text>,
    )
  }

  const url = project.icon_url && !broken ? resolveUploadsUrl(project.icon_url) : ''

  if (url) {
    return slot(
      <img
        src={url}
        alt=""
        width={boxSize}
        height={boxSize}
        style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
        onError={() => setBroken(true)}
      />,
    )
  }

  const dot = Math.max(6, Math.round(boxSize * 0.4))
  return slot(
    <Box
      w={dot}
      h={dot}
      style={{
        borderRadius: '50%',
        background: project.color || 'var(--mantine-color-gray-5)',
        flexShrink: 0,
      }}
    />,
  )
}
